<template>
    <div
        class="event-details__wrapper event-details__wrapper--streams"
    >
        <MatchVisualization
            v-if="selectedStreamSection === streamSections.Visualization"
            :betRadarId="betRadarId"
        />
        <VideoContainer
            v-else-if="isVideo"
            :key="selectedStreamSection"
            v-bind="dockedVideoStream"
            :isPinned="true"
            :isDetached="shouldDisplayDockedStream"
            :isSignedIn="!!user"
            @videoPinClick="unpinVideo"
            @videoCloseClick="closeDockedStream"
            @requestLogin="openLoginModal"
            @resumePlayback="playStream({ id: expandedEvent })"
            @startPlaying="playStream({ id: expandedEvent })"
            @toggleSound="toggleDockedVideoSound"
            @videoUnavailable="setIsVideoUnavailable"
        />
    </div>
</template>

<script>
    import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';
    import {
        mapGetters,
        mapActions,
    } from 'vuex';

    import { StreamSection } from '@app/store/modules/ui/sportOffer/sportPage/enums';
    import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

    import MatchVisualization from './MatchVisualization.vue';
    import VideoContainer from './VideoContainer';

    export default {
        name: 'StreamsAndVisualizationsContainer',
        props: {
            selectedStream: {
                type: Number,
                required: false,
                default: undefined,
            },
        },
        created() {
            this.streamSections = StreamSection;
            this.isVisualisationOpened = false;
        },
        computed: {
            ...mapGetters('ui/sportOffer', [
                'dockedVideoStream',
                'shouldDisplayDockedStream',
                'selectedStreamSection',
                'expandedEvent',
                'expandedEventData',
                'availableStreamSections',
            ]),
            isMobileLayout() {
                return isMobileLayout();
            },
            ...mapGetters('data/authentication', [
                'user',
            ]),
            betRadarId() {
                return this.expandedEventData?.betRadarId;
            },
            isVideo() {
                return [
                    this.streamSections.Video,
                    this.streamSections.Youtube,
                    this.streamSections.Twitch,
                    this.streamSections.Perform,
                    this.streamSections.BetGenius,
                    this.streamSections.Img,
                    this.streamSections.Infrontsports,
                    this.streamSections.Beter,
                ].includes(this.selectedStreamSection);
            },
        },
        watch: {
            betRadarId(value, oldValue) {
                if (value && value !== oldValue) {
                    this.isVisualisationOpened = false;
                }
            },
            selectedStream: {
                handler(value) {
                    if (value) {
                        this.setSection(value, { isToggle: false });
                    }
                },
                immediate: true,
            },
        },
        methods: {
            ...mapActions('ui/sportOffer', [
                'unpinVideo',
                'closeDockedStream',
                'playStream',
                'toggleDockedVideoSound',
                'setIsVideoUnavailable',
                'toggleSelectedStreamSection',
                'setSelectedStreamSection',
            ]),
            ...mapActions('ui/sportOffer', [
                'prepareStream',
            ]),
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            openLoginModal() {
                this.setModal(modalCodes.login);
            },
            setSection(section, { isToggle }) {
                if (isToggle) {
                    this.toggleSelectedStreamSection(section);
                } else {
                    this.setSelectedStreamSection(section);
                }
                this.prepareStream({ match: this.expandedEventData, streamSection: section });
            },
        },
        components: {
            VideoContainer,
            MatchVisualization,
        },
    };
</script>
